import React, {useCallback} from 'react';
import {toast} from 'react-toastify';
import {useDispatch} from 'react-redux';
import {t} from '@lingui/core/macro';

import {INotifyChannel} from 'entities/notification';
import {fetchMe} from 'entities/user';
import ConfirmModal from 'shared/ui/Modal/ConfirmModal/ConfirmModal';
import {TypedDispatch} from 'shared/model/types';
import {INotifyChannelApi} from 'features/profile/model/notifyChannelApi';

interface INotifyChannelDeleteModalProps<T extends INotifyChannel> {
    item: T,
    api: INotifyChannelApi<T>,
    open: boolean,
    handleClose: () => void,
    header: string,
    question: string,
    name: string,
    successText: string,
}

const NotifyChannelDeleteModal = <T extends INotifyChannel>({
    item,
    api,
    open,
    handleClose,
    header,
    question,
    name,
    successText,
}: INotifyChannelDeleteModalProps<T>) => {
    const dispatch = useDispatch<TypedDispatch>();
    const [deleteItem] = api.useDeleteMutation();

    const onClickDelete = useCallback(async() => {
        const result = await deleteItem(item.id);
        if ('error' in result) return;
        dispatch(fetchMe());
        toast.info(successText);
        handleClose();
    }, [deleteItem, dispatch, item.id, successText, handleClose]);

    return (
        <ConfirmModal
            variant="delete"
            open={open}
            handleClose={handleClose}
            header={header}
            title={question}
            name={name}
            confirmText={t`Удалить`}
            onConfirm={onClickDelete}
        />
    );
};

export default NotifyChannelDeleteModal;
